import React from "react";

import { formConstants } from "../../../helpers/vorgange";
import LegalPersonVollmachtTab from "./LegalPersonVollmachtTab";
import NaturalPersonVollmachtTab from "./NaturalPersonVollmachtTab";

const VollmachtTab = (props) => {
  if (props.personenform === formConstants.individualPerson) {
    return <NaturalPersonVollmachtTab {...props} />;
  }

  return <LegalPersonVollmachtTab {...props} />;
};

export default VollmachtTab;
